import appReducer from './appReducer'
import metaDataReducer from './metaDataReducer'
import authenticationReducer from './apiReducers/authenticationReducer'
import registerReducer from './apiReducers/registerReducer'
import serviceAvailableReducer from './apiReducers/serviceAvailableReducer'
import caseOweAmountReducer from './apiReducers/caseOweAmountReducer'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  app: appReducer,
  metaData: metaDataReducer,
  authentication: authenticationReducer,
  register: registerReducer,
  serviceAvailable: serviceAvailableReducer,
  caseOweAmount: caseOweAmountReducer,
})

export default rootReducer
